import React from 'react';
import { LoaderCircle } from 'lucide-react';
import { cx } from './classNames';
import './ui.css';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps {
  size?: SpinnerSize;
  /** 琥珀で描く（ページ中央のローディングなど、文脈色が無い場所向け） */
  primary?: boolean;
  /** 読み上げ用の文言。視覚的には出さない */
  label?: string;
  className?: string;
}

export function Spinner({ size = 'md', primary = false, label = '読み込み中', className }: SpinnerProps) {
  return (
    <span
      className={cx('ui-spinner', `ui-spinner--${size}`, primary && 'ui-spinner--primary', className)}
      role="status"
      aria-live="polite"
      data-testid="ui-spinner"
    >
      <LoaderCircle aria-hidden="true" />
      <span className="ui-sr-only">{label}</span>
    </span>
  );
}
